module.exports = __webpack_public_path__ + "static/media/tick.a785c129.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tick.svg
// module id = 1493
// module chunks = 0